import React from "react";
import { ViewMoreIcon } from "../assets/icons";
import useDeleteData from "../hooks/useDeleteData";

function CommonViewMore({ data={}, fetcher=()=>{},link="" }) {
  const { handleDelete } = useDeleteData();
  
  return (
    <>
      <div className="hover:drop-shadow-sm mr-2 py-2 px-[7px] rounded-3xl h-8 bg-white dropdown cursor-pointer relative">
        <ViewMoreIcon />
        <div className="hidden dropdown-menu">
          <div
            id="modal"
            className="bg-transparent fixed inset-0 flex justify-center items-center "
          ></div>
          <div className="bg-white rounded-xl w-16 absolute -left-16 -top-1">
            <div className="grid p-1 rounded-t">
              <span
                className="p-1 hover:bg-navhover hover:rounded-lg cursor-pointer text-sm"
                onClick={() =>
                  handleDelete({
                    url: `/${link}/${data?.id}/`,
                    id: data?.id,
                    value: data?.image_name,
                    fetcher: fetcher,
                  })
                }
              >
                Delete
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CommonViewMore;
